import {
  createMaintenanceDashboardLayoutLoadingChangedAction,
  MAINTENANCE_DASHBOARD_LAYOUT_LOADING_CHANGED,
} from "../actions/maintenanceDashboardLoadingState";

export interface IMaintenanceDashboardLayoutLoadingState {
  loading: boolean;
}

export const initialMaintenanceDashboardLayoutLoadingState: IMaintenanceDashboardLayoutLoadingState = {
  loading: true,
};

export const maintenanceDashboardLoadingStateReducer = (
  previousState: IMaintenanceDashboardLayoutLoadingState = initialMaintenanceDashboardLayoutLoadingState,
  action: ReturnType<
    typeof createMaintenanceDashboardLayoutLoadingChangedAction
  >
): IMaintenanceDashboardLayoutLoadingState => {
  switch (action.type) {
    case MAINTENANCE_DASHBOARD_LAYOUT_LOADING_CHANGED:
      return {
        loading: action.payload,
      };
  }

  return previousState;
};
